

function Remove(idds) {
    var input = $('#quantity');
    var val = parseInt(input.val());
    if (val > 1) {
        input.val(val - 1);
    }
    Check(idds);
}

function Add(idds) {
    var input = $('#quantity');
    var val = parseInt(input.val());
    input.val(val + 1);
    Check(idds);
}

function Check(idds) {
    var cdc = 0;
    var valore = $('#quantity').val();
    valore = valore.replace(/[^\d]/g, '');
    $('#quantity').val(valore);


    if (valore.trim() == '' || valore == '0') {
        $('#quantity').val('1');
    }

    if (IsUserPlus() === true) {
        const listcdc = $('#listcdc').dxSelectBox('instance');

        if (listcdc != null && listcdc != undefined) {
            var item = listcdc.option('selectedItem');
            if (item) {
                cdc = item.Key;
            }
        }
    }

    $('#lnkalternative').attr('href', '/Prodotti/ProdottiAlternativi/' + idds + '/' + cdc + '/' + valore);
};

const sbVarianteProdottoChanged = function (e) {
    try {
        const previousValue = e.previousValue;
        const newValue = e.value;

        window.location.href = newValue;

    } catch (error) {
        console.log(e);
        console.log(error);
    }
};

const VarianteGriglia_RowClick = function (e) {
    var link = '';
    if (e.data.Url.includes('/Prodotti/')) {
        link = e.data.Url;
    }
    else {
        link = '/Prodotti/' + e.data.IDDS;
    }
    window.location.href = link;
};


function ScrollInPage(target) {
    scrollTo($(target)[0].offsetLeft, $(target)[0].offsetTop - document.getElementsByTagName('header')[0].offsetTop)
}


function listcdc_selectionChanged(data, idds) {

    try {
        var item = data.component.option("selectedItem");
        var cdc = 0;
        var qta = 1;
        var quantity = $("#quantity");
        if (item) {
            cdc = item.Key;
        }
        if (quantity && quantity.val() > 0) {
            qta = quantity.val();
        }
        $("#lnkalternative").attr("href", "/Prodotti/ProdottiAlternativi/" + idds + "/" + cdc + "/" + qta);

    }
    catch (err) {
        console.log(err);
    }
}

function InizializzaSchedaProdotto(prodotto) {
    try {
        prodotto = JSON.parse(prodotto);
        GestioneImmaginiSchedaProdotto();             

        AddCardAccount(prodotto);
        if (typeof dataLayer != 'undefined') {
            var pr = '';
            if (prodotto.HasPromozione === true) {
                pr = prodotto.PrezzoFinalePromozione.replace(",", ".");
            }
            else {
                pr = prodotto.PrezzoFinale.replace(",", ".");
            }

            var p = {};
            p.id = prodotto.IDDS;
            p.name = prodotto.Nome;
            p.category = prodotto.Categorie[prodotto.Categorie.length - 1].Value + ' ' + (prodotto.Categorie[prodotto.Categorie.length - 1].Key);
            p.brand = prodotto.Marca;
            p.price = parseFloat(pr);
            p.variant = '';
            p.quantity = 1;
            p.i = '1';
            p.listname = 'Scheda prodotto';

            ga4.e_pushEvent(p, 'view_item', 'EUR');
        }
        
    }
    catch (error) {
        console.log(error);
    }
}


function GestioneImmaginiSchedaProdotto() {

    $(".secondaryimages").click(function () {
        try {
            var ImmagineZoom = $('#main-img').attr('data-ImmagineZoom');
            var ImmagineMedia = $('#main-img').attr('data-ImmagineMedia');
            var ImmagineMini = $('#main-img').attr('data-ImmagineMini');

            $('#main-img').attr('data-ImmagineZoom', $(this).attr('data-ImmagineZoom'));
            $('#main-img').attr('data-ImmagineMedia', $(this).attr('data-ImmagineMedia'));
            $('#main-img').attr('data-ImmagineMini', $(this).attr('data-ImmagineMini'));

            $('#main-img').attr('data-zoom', $(this).attr('data-ImmagineZoom'));
            $('#main-img').attr('src', $(this).attr('data-ImmagineMedia'));
            $('#main-img').attr('xoriginal', $(this).attr('data-ImmagineMedia'));
            $('#main-img').parent().attr('href', $(this).attr('data-ImmagineZoom'));

            $(this).attr('data-ImmagineZoom', ImmagineZoom);
            $(this).attr('data-ImmagineMedia', ImmagineMedia);
            $(this).attr('data-ImmagineMini', ImmagineMini);

            $(this).attr('data-zoom', ImmagineZoom);
            $(this).attr('src', ImmagineMedia);
            $(this).attr('xoriginal', ImmagineMedia);

            $('#' + this.id).attr('src', ImmagineMini);

        }
        catch (error) {
            console.log(error);
        }
    });
    new VenoBox();
}

function AddCardAccount(prodotto) {
    $('#quantity').val('1');
    $('#addCartBtn').on('click', function () {
        var cdc = 0;
        var quantityValue = $('#quantity').val();

        const listcdc = $('#listcdc').dxSelectBox('instance');

        if (listcdc != null && listcdc != undefined) {
            cdc = parseInt(listcdc.option('value'));
        }

        checkoutController.AccountAddCart(prodotto.IDDS, quantityValue, cdc, 'prodotto');
    });
}

function CheckConsensi() {
    try {

        var params = new URLSearchParams(window.location.href);
        var servizio = params.get('CS');
        var base = params.get('CB');

        if (servizio == 'false' || base == 'false') {
            $('#PopupConsensi').dxPopup('instance').show()
        }

    } catch (err) {
        console.log(err);
    }
}
